import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import {
	DateInput,
	PhoneInput,
	SelectInput,
} from '../../../../../components/form-components/inputs.component'
import Yup from '../../../../../helpers/custom-yup'

const schema = Yup.object().shape({
	phone: Yup.string().phone().required('Informe o telefone'),
})

const StyledForm = styled.div`
	padding-bottom: 25px;
	width: 300px;
	@media (max-width: 600px) {
		width: 100%;
	}
`

const StyledInputContainer = styled.div`
	margin-top: 4rem;
`

export default class ComplementaryForm extends Component {
	constructor(props) {
		super(props)
		this.phoneRef = React.createRef()
	}

	submit() {
		this.refs.form.submitForm()
	}

	componentWillMount() {
		const { birthday, gender, phone } = this.props.initialValues
		this.initialValues = { birthday, gender, phone }
	}

	render() {
		const { onSubmit } = this.props
		return (
			<Formik
				initialValues={this.initialValues}
				onSubmit={onSubmit}
				validationSchema={schema}
				ref={'form'}
				render={(props) => (
					<Form noValidate>
						<StyledForm>
							<DateInput
								disabled
								elementRef={this.birthdayRef}
								id="birthday"
								label="Data de nascimento"
								{...props}
							/>
							{/* <StyledInputContainer>
								<SelectInput
									disabled
									elementRef={this.genderRef}
									id="gender"
									label="Sexo"
									placeholder="Selecione ..."
									options={[
										{ value: 'F', label: 'Feminino' },
										{ value: 'M', label: 'Masculino' },
										{ value: 'O', label: 'Outros' },
									]}
									multi={false}
									{...props}
								/>
							</StyledInputContainer> */}
							<StyledInputContainer>
								<PhoneInput
									elementRef={this.phoneRef}
									id="phone"
									label="Telefone *"
									{...props}
								/>
							</StyledInputContainer>
						</StyledForm>
					</Form>
				)}
			/>
		)
	}
}

ComplementaryForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func,
}
